// extracted by mini-css-extract-plugin
module.exports = {"border-primary":"SubscriptionsCards_border-primary__1ZwDY","btn-current":"SubscriptionsCards_btn-current__KjsTI"};